let wildcardDomain = () => {
	return document.location.hostname.split('.').slice(-2).join('.');
};

export default wildcardDomain;